import validate from 'helpers/validate'
import {
  NewPasswordType,
  RegisterForm,
  RegistrationFormErrors,
  RegistrationUIDErrorType
} from 'redux/registration/typings'

interface ValidateRegistrationFormOptions {
  registerForm: RegisterForm
  formErrors: RegistrationFormErrors
}

interface ValidateErrorsOptions {
  errors: RegistrationFormErrors
  isUniqueUserId: boolean
}

export const validateRegistrationForm = ({
  formErrors,
  registerForm
}: ValidateRegistrationFormOptions): RegistrationFormErrors => {
  let newErrors: RegistrationFormErrors
  Object.keys(formErrors).forEach(key => {
    const value = registerForm[key as keyof RegisterForm]
    const validationError = validate(key, value)
    newErrors = { ...newErrors, [key]: validationError }
  })

  return newErrors
}

export const validateErrors = ({
  errors,
  isUniqueUserId
}: ValidateErrorsOptions): string | boolean => {
  return (
    Object.keys(errors).find(
      errorKey =>
        errorKey !== 'newPassword' &&
        errorKey !== 'registrationUID' &&
        errors[errorKey as keyof RegistrationFormErrors]
    ) ||
    Object.keys(errors.registrationUID).find(
      registrationUIDKey =>
        !errors.registrationUID[
          registrationUIDKey as keyof RegistrationUIDErrorType
        ]
    ) ||
    Object.keys(errors.newPassword).find(
      newPasswordErrorKey =>
        !errors.newPassword[newPasswordErrorKey as keyof NewPasswordType]
    ) ||
    !isUniqueUserId
  )
}
